import { API_URL } from "../Constants"
import { startLoading, endLoading, SnackBar } from './Common';
import store from "../store"

export function pageQustionUpdate(name) {
    return { type: 'PAGE_QUESTION_UPDATED', name };
}

export function storeVoluntaryQn(data) {
    return { type: 'STORE_VOLUNTARY_QUESTIONS', data };
}

export function getVoluntaryQn() {
    return function (dispatch) {
        dispatch(startLoading())
        dispatch(SnackBar(true, 'Loading.....', 'info'))
        fetch(API_URL + "questionnaire?qn=voluntary_questionnaire", {
            method: "GET",
            headers: {
                'Content-Type': 'application/json;charset=utf-8',
                'Authorization': 'Bearer ' + store.getState().auth.access_token
            }
        }).then(response => response.json(), error => console.log('An error occurred.', error))
            .then((json) => {
                dispatch(storeVoluntaryQn(json))
                dispatch(endLoading())
            })
    }
}

export function updateVoluntaryQn(data) {
    return function (dispatch) {
        dispatch(startLoading())
        dispatch(SnackBar(true, 'Updating..', 'info'))
        fetch(API_URL + "questionnaire-voluntary", {
            method: "POST",
            headers: {
                'Content-Type': 'application/json;charset=utf-8',
                'Authorization': 'Bearer ' + store.getState().auth.access_token
            },
            body: JSON.stringify({data})
        }).then(response => response.json(), error => console.log('An error occurred.', error))
            .then((json) => {
                if (json.status == "success") {
                    dispatch(essentialQnUpdated("voluntary"))
                    dispatch(pageQustionUpdate("voluntary_test"))
                }
                dispatch(endLoading())
            })
    }
}

export function storeEssentialQn(data) {
    return { type: 'STORE_ESSENTIAL_QUESTIONS', data };
}

export function getEssentialQn() {
    return function (dispatch) {
        dispatch(startLoading())
        dispatch(SnackBar(true, 'Loading.....', 'info'))
        fetch(API_URL + "questionnaire?qn=essential_questionnaire", {
            method: "GET",
            headers: {
                'Content-Type': 'application/json;charset=utf-8',
                'Authorization': 'Bearer ' + store.getState().auth.access_token
            }
        }).then(response => response.json(), error => console.log('An error occurred.', error))
            .then((json) => {
                dispatch(storeEssentialQn(json))
                dispatch(endLoading())
            })
    }
}


export function essentialQnUpdated(data = null) {
    return { type: 'ESSENTIAL_QUESTION_UPDATED', data };
}

export function updateEssentialQn(data) {
    return function (dispatch) {
        dispatch(startLoading())
        dispatch(SnackBar(true, 'Updating..', 'info'))
        fetch(API_URL + "questionnaire-essential", {
            method: "POST",
            headers: {
                'Content-Type': 'application/json;charset=utf-8',
                'Authorization': 'Bearer ' + store.getState().auth.access_token
            },
            body: JSON.stringify({data})
        }).then(response => response.json(), error => console.log('An error occurred.', error))
            .then((json) => {
                dispatch(endLoading())
                if (json.status == "success") {
                    dispatch(essentialQnUpdated("essential"))
                    dispatch(pageQustionUpdate("essential_test"))
                }
            })
    }
}

export function storeDailyQn(data) {
    return { type: 'STORE_DAILY_QUESTIONS', data };
}


export function storeFeedBackQn(data) {
    return { type: 'STORE_FEEDBACK_QUESTIONS', data };
}

export function showFeedBackPopup(bool) {
    return { type: 'SHOW_FEEDBACK_POPUP', bool };
}

export function getFeedBackQn() {
    return function (dispatch) {
        dispatch(startLoading())
        fetch(API_URL + "feedBackQuestions", {
            method: "GET",
            headers: {
                'Content-Type': 'application/json;charset=utf-8',
                'Authorization': 'Bearer ' + store.getState().auth.access_token
            }
        }).then(response => response.json(), error => console.log('An error occurred.', error))
            .then((json) => {
                if(json.show) {
                     dispatch(storeFeedBackQn(json))
                }
                dispatch(endLoading())
            })
    }
}


export function saveFeedback(data) {
    return function (dispatch) {
        dispatch(startLoading())
        dispatch(showFeedBackPopup(false))
        fetch(API_URL + "feedback/save", {
            method: "POST",
            headers: {
                'Content-Type': 'application/json;charset=utf-8',
                'Authorization': 'Bearer ' + store.getState().auth.access_token
            },
            body: JSON.stringify({data})
        }).then(response => response.json(), error => console.log('An error occurred.', error))
            .then((json) => {
                if(json.status=="success") {
                    dispatch(SnackBar(true, 'Feedback updated successfully', 'success'))
                } else {
                    dispatch(SnackBar(true, 'Feedback upload failed', 'danger'))
                }
                dispatch(endLoading())
            })
    }
}

export function getDailyQn(uid = null) {
    return function (dispatch) {
        dispatch(startLoading())
        dispatch(getFeedBackQn())
        dispatch(SnackBar(true, 'Loading.....', 'info'))
        fetch(API_URL + "questionnaire?qn=daily_questionnaire" + "&uid=" + uid, {
            method: "GET",
            headers: {
                'Content-Type': 'application/json;charset=utf-8',
                'Authorization': 'Bearer ' + store.getState().auth.access_token
            }
        }).then(response => response.json(), error => console.log('An error occurred.', error))
            .then((json) => {
                dispatch(storeDailyQn(json))
                dispatch(endLoading())
            })
    }
}

export function updateDailyQn(data, uid = null) {
    return function (dispatch) {
        dispatch(startLoading())
        dispatch(SnackBar(true, 'Updating..', 'info'))
        fetch(API_URL + "questionnaire?qn=daily_questionnaire" + "&uid=" + uid, {
            method: "POST",
            headers: {
                'Content-Type': 'application/json;charset=utf-8',
                'Authorization': 'Bearer ' + store.getState().auth.access_token
            },
            body: JSON.stringify({data})
        }).then(response => response.json(), error => console.log('An error occurred.', error))
            .then((json) => {
                if (json.status == "success") {
                    dispatch(getDailyQn(uid))
                    dispatch(essentialQnUpdated("daily"))
                    dispatch(showFeedBackPopup(true))
                }
                dispatch(endLoading())
            })
    }
}

export function storeTestScore(data) {
    return { type: 'STORE_TEST_SCORE_LIST', data };
}

export function getPastScore() {
    return function (dispatch) {
        dispatch(startLoading())
        dispatch(SnackBar(true, 'Loading.....', 'info'))
        fetch(API_URL + "account/test-history", {
            method: "GET",
            headers: {
                'Content-Type': 'application/json;charset=utf-8',
                'Authorization': 'Bearer ' + store.getState().auth.access_token
            }
        }).then(response => response.json(), error => console.log('An error occurred.', error))
            .then((json) => {
                dispatch(storeTestScore(json.data))
                dispatch(endLoading())
            })
    }
}